import { render, staticRenderFns } from "./expertMembers.vue?vue&type=template&id=276a57df&scoped=true"
import script from "./expertMembers.vue?vue&type=script&lang=js"
export * from "./expertMembers.vue?vue&type=script&lang=js"
import style0 from "./expertMembers.vue?vue&type=style&index=0&id=276a57df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276a57df",
  null
  
)

export default component.exports